(function () {
  'use strict';

  /* Directives */
  angular.module('wsLrs.directives').
  /* expects either mbox and name or userId and name; and expects isGroup (which is treated as a function
   to keep the value a boolean and not a string)
   Size is not used right now as an attribute because the css is always going to display at 48px */
  directive('wsInteractions', ['$routeParams', 'Interactions', 'TinCanJS', 'CardDisplay', function wsInteractions($routeParams, Interactions, TinCanJS, CardDisplay) {
    return {
      restrict: 'AE',
      scope: {
        isLegacy: "=?",
        isPreview: "=?",
        limit: "=?",
        card: "=",
        scrollable: "=",
        baseUrl: "=?",
        hasData: "=?",
        statements: "=?",
        showAvatar: "=?"
      },
      templateUrl: 'modules/common/directives/ws-interactions/ws-interactions.html',
      link: function link(scope, element, attrs) {
        // Set defaults
        if (!attrs.isLegacy) {
          scope.isLegacy = false;
        }
        if (!attrs.isPreview) {
          scope.isPreview = false;
        }
        if (!attrs.limit) {
          scope.limit = 50;
        }
        if (!attrs.limit && scope.isPreview) {
          scope.limit = 5;
        }
        var limit = scope.card ? CardDisplay.getLimitParam(scope.card.id) : 5;
        if (limit && !attrs.limit) {
          scope.limit = limit;
        }

        // We ultimately are passing params and isPreview and possibly a baseUrl to Interactions
        var params = {};
        if (scope.statements) {
          if (scope.statements.length > 0) {
            scope.hasData = true;
            scope.statements = TinCanJS.getExtendedDecoratedStatements(scope.statements);
          } else {
            scope.hasData = false;
          }
          return;
        }
        if (scope.isPreview) {
          // Just need the filter, clear out the program because it can be huge
          var config = angular.copy(scope.card.configuration);
          delete config.program;
          params.config = config;
        } else {
          params.cardId = scope.card.id;
        }
        params.limit = scope.limit;

        // Statement fetching logic
        scope.statements = [];
        scope.fetchStatementsInProgress = false;
        scope.hasMoreStatements = false;
        var oldestTimestamp = null;
        function fetchStatements(params) {
          if (scope.fetchStatementsInProgress) {
            return;
          }
          scope.fetchStatementsInProgress = true;
          scope.hasMoreStatements = false;
          oldestTimestamp = null;
          Interactions.get(params, scope.isPreview, scope.baseUrl).then(function (statements) {
            Array.prototype.push.apply(scope.statements, TinCanJS.getExtendedDecoratedStatements(statements));
            scope.hasData = scope.statements.length > 0;
            scope.hasMoreStatements = statements.length > params.limit / 2;
            if (scope.hasMoreStatements) {
              oldestTimestamp = statements[statements.length - 1].timestamp;
            }
            scope.fetchStatementsInProgress = false;
          }, function (err) {
            if (err.status === -1) {// jshint ignore:line
              // Do nothing because the promise was cancelled
            } else {
              return err;
            }
          });
        }

        // Executed as part of an infinite scroll interaction, via wsInfiniteScroll directive
        scope.loadMoreStatements = function () {
          if (!scope.fetchStatementsInProgress && !scope.hasMoreStatements) {
            return false;
          }
          params.until = oldestTimestamp;
          fetchStatements(params);
        };

        // Fire off the first fetch statements call
        fetchStatements(params);
      }
    };
  }]);
})();
